export interface CountryItem {
    id: string;
    name: string;
  }

export const COUNTRIES: CountryItem[] = [
    { name: 'Afghanistan', id: 'AF' },
{ name: 'Albania', id: 'AL' },
{ name: 'Algeria', id: 'DZ' },
{ name: 'American Samoa', id: 'AS' },
{ name: 'Andorra', id: 'AD' },
{ name: 'Angola', id: 'AO' },
{ name: 'Anguilla', id: 'AI' },
{ name: 'Antarctica', id: 'AQ' },
{ name: 'Antigua and Barbuda', id: 'AG' },
{ name: 'Argentina', id: 'AR' },
{ name: 'Armenia', id: 'AM' },
{ name: 'Aruba', id: 'AW' },
{ name: 'Australia', id: 'AU' },
{ name: 'Austria', id: 'AT' },
{ name: 'Azerbaijan', id: 'AZ' },
{ name: 'Bahamas (the)', id: 'BS' },
{ name: 'Bahrain', id: 'BH' },
{ name: 'Bangladesh', id: 'BD' },
{ name: 'Barbados', id: 'BB' },
{ name: 'Belarus', id: 'BY' },
{ name: 'Belgium', id: 'BE' },
{ name: 'Belize', id: 'BZ' },
{ name: 'Benin', id: 'BJ' },
{ name: 'Bermuda', id: 'BM' },
{ name: 'Bhutan', id: 'BT' },
{ name: 'Bolivia (Plurinational State of)', id: 'BO' },
{ name: 'Bonaire, Sint Eustatius and Saba', id: 'BQ' },
{ name: 'Bosnia and Herzegovina', id: 'BA' },
{ name: 'Botswana', id: 'BW' },
{ name: 'Bouvet Island', id: 'BV' },
{ name: 'Brazil', id: 'BR' },
{ name: 'British Indian Ocean Territory (the)', id: 'IO' },
{ name: 'Brunei Darussalam', id: 'BN' },
{ name: 'Bulgaria', id: 'BG' },
{ name: 'Burkina Faso', id: 'BF' },
{ name: 'Burundi', id: 'BI' },
{ name: 'Cabo Verde', id: 'CV' },
{ name: 'Cambodia', id: 'KH' },
{ name: 'Cameroon', id: 'CM' },
{ name: 'Canada', id: 'CA' },
{ name: 'Cayman Islands (the)', id: 'KY' },
{ name: 'Central African Republic (the)', id: 'CF' },
{ name: 'Chad', id: 'TD' },
{ name: 'Chile', id: 'CL' },
{ name: 'China', id: 'CN' },
{ name: 'Christmas Island', id: 'CX' },
{ name: 'Cocos (Keeling) Islands (the)', id: 'CC' },
{ name: 'Colombia', id: 'CO' },
{ name: 'Comoros (the)', id: 'KM' },
{ name: 'Congo (the Democratic Republic of the)', id: 'CD' },
{ name: 'Congo (the)', id: 'CG' },
{ name: 'Cook Islands (the)', id: 'CK' },
{ name: 'Costa Rica', id: 'CR' },
{ name: 'Croatia', id: 'HR' },
{ name: 'Cuba', id: 'CU' },
{ name: 'CuraÃ§ao', id: 'CW' },
{ name: 'Cyprus', id: 'CY' },
{ name: 'Czechia', id: 'CZ' },
{ name: 'Ivory Coast', id: 'CI' },
{ name: 'Denmark', id: 'DK' },
{ name: 'Djibouti', id: 'DJ' },
{ name: 'Dominica', id: 'DM' },
{ name: 'Dominican Republic (the)', id: 'DO' },
{ name: 'Ecuador', id: 'EC' },
{ name: 'Egypt', id: 'EG' },
{ name: 'El Salvador', id: 'SV' },
{ name: 'Equatorial Guinea', id: 'GQ' },
{ name: 'Eritrea', id: 'ER' },
{ name: 'Estonia', id: 'EE' },
{ name: 'Eswatini', id: 'SZ' },
{ name: 'Ethiopia', id: 'ET' },
{ name: 'Falkland Islands (the) [Malvinas]', id: 'FK' },
{ name: 'Faroe Islands (the)', id: 'FO' },
{ name: 'Fiji', id: 'FJ' },
{ name: 'Finland', id: 'FI' },
{ name: 'France', id: 'FR' },
{ name: 'French Guiana', id: 'GF' },
{ name: 'French Polynesia', id: 'PF' },
{ name: 'French Southern Territories (the)', id: 'TF' },
{ name: 'Gabon', id: 'GA' },
{ name: 'Gambia (the)', id: 'GM' },
{ name: 'Georgia', id: 'GE' },
{ name: 'Germany', id: 'DE' },
{ name: 'Ghana', id: 'GH' },
{ name: 'Gibraltar', id: 'GI' },
{ name: 'Greece', id: 'GR' },
{ name: 'Greenland', id: 'GL' },
{ name: 'Grenada', id: 'GD' },
{ name: 'Guadeloupe', id: 'GP' },
{ name: 'Guam', id: 'GU' },
{ name: 'Guatemala', id: 'GT' },
{ name: 'Guernsey', id: 'GG' },
{ name: 'Guinea', id: 'GN' },
{ name: 'Guinea-Bissau', id: 'GW' },
{ name: 'Guyana', id: 'GY' },
{ name: 'Haiti', id: 'HT' },
{ name: 'Heard Island and McDonald Islands', id: 'HM' },
{ name: 'Holy See (the)', id: 'VA' },
{ name: 'Honduras', id: 'HN' },
{ name: 'Hong Kong', id: 'HK' },
{ name: 'Hungary', id: 'HU' },
{ name: 'Iceland', id: 'IS' },
{ name: 'India', id: 'IN' },
{ name: 'Indonesia', id: 'ID' },
{ name: 'Iran (Islamic Republic of)', id: 'IR' },
{ name: 'Iraq', id: 'IQ' },
{ name: 'Ireland', id: 'IE' },
{ name: 'Isle of Man', id: 'IM' },
{ name: 'Israel', id: 'IL' },
{ name: 'Italy', id: 'IT' },
{ name: 'Jamaica', id: 'JM' },
{ name: 'Japan', id: 'JP' },
{ name: 'Jersey', id: 'JE' },
{ name: 'Jordan', id: 'JO' },
{ name: 'Kazakhstan', id: 'KZ' },
{ name: 'Kenya', id: 'KE' },
{ name: 'Kiribati', id: 'KI' },
{ name: 'Korea (the Democratic Peoples Republic of)', id: 'KP' },
{ name: 'Korea (the Republic of)', id: 'KR' },
{ name: 'Kuwait', id: 'KW' },
{ name: 'Kyrgyzstan', id: 'KG' },
{ name: 'Lao Peoples Democratic Republic (the)', id: 'LA' },
{ name: 'Latvia', id: 'LV' },
{ name: 'Lebanon', id: 'LB' },
{ name: 'Lesotho', id: 'LS' },
{ name: 'Liberia', id: 'LR' },
{ name: 'Libya', id: 'LY' },
{ name: 'Liechtenstein', id: 'LI' },
{ name: 'Lithuania', id: 'LT' },
{ name: 'Luxembourg', id: 'LU' },
{ name: 'Macao', id: 'MO' },
{ name: 'Madagascar', id: 'MG' },
{ name: 'Malawi', id: 'MW' },
{ name: 'Malaysia', id: 'MY' },
{ name: 'Maldives', id: 'MV' },
{ name: 'Mali', id: 'ML' },
{ name: 'Malta', id: 'MT' },
{ name: 'Marshall Islands (the)', id: 'MH' },
{ name: 'Martinique', id: 'MQ' },
{ name: 'Mauritania', id: 'MR' },
{ name: 'Mauritius', id: 'MU' },
{ name: 'Mayotte', id: 'YT' },
{ name: 'Mexico', id: 'MX' },
{ name: 'Micronesia (Federated States of)', id: 'FM' },
{ name: 'Moldova (the Republic of)', id: 'MD' },
{ name: 'Monaco', id: 'MC' },
{ name: 'Mongolia', id: 'MN' },
{ name: 'Montenegro', id: 'ME' },
{ name: 'Montserrat', id: 'MS' },
{ name: 'Morocco', id: 'MA' },
{ name: 'Mozambique', id: 'MZ' },
{ name: 'Myanmar', id: 'MM' },
{ name: 'Namibia', id: 'NA' },
{ name: 'Nauru', id: 'NR' },
{ name: 'Nepal', id: 'NP' },
{ name: 'Netherlands (the)', id: 'NL' },
{ name: 'New Caledonia', id: 'NC' },
{ name: 'New Zealand', id: 'NZ' },
{ name: 'Nicaragua', id: 'NI' },
{ name: 'Niger (the)', id: 'NE' },
{ name: 'Nigeria', id: 'NG' },
{ name: 'Niue', id: 'NU' },
{ name: 'Norfolk Island', id: 'NF' },
{ name: 'Northern Mariana Islands (the)', id: 'MP' },
{ name: 'Norway', id: 'NO' },
{ name: 'Oman', id: 'OM' },
{ name: 'Pakistan', id: 'PK' },
{ name: 'Palau', id: 'PW' },
{ name: 'Palestine, State of', id: 'PS' },
{ name: 'Panama', id: 'PA' },
{ name: 'Papua New Guinea', id: 'PG' },
{ name: 'Paraguay', id: 'PY' },
{ name: 'Peru', id: 'PE' },
{ name: 'Philippines (the)', id: 'PH' },
{ name: 'Pitcairn', id: 'PN' },
{ name: 'Poland', id: 'PL' },
{ name: 'Portugal', id: 'PT' },
{ name: 'Puerto Rico', id: 'PR' },
{ name: 'Qatar', id: 'QA' },
{ name: 'Republic of North Macedonia', id: 'MK' },
{ name: 'Romania', id: 'RO' },
{ name: 'Russian Federation (the)', id: 'RU' },
{ name: 'Rwanda', id: 'RW' },
{ name: 'RÃ©union', id: 'RE' },
{ name: 'Saint BarthÃ©lemy', id: 'BL' },
{ name: 'Saint Helena, Ascension and Tristan da Cunha', id: 'SH' },
{ name: 'Saint Kitts and Nevis', id: 'KN' },
{ name: 'Saint Lucia', id: 'LC' },
{ name: 'Saint Martin (French part)', id: 'MF' },
{ name: 'Saint Pierre and Miquelon', id: 'PM' },
{ name: 'Saint Vincent and the Grenadines', id: 'VC' },
{ name: 'Samoa', id: 'WS' },
{ name: 'San Marino', id: 'SM' },
{ name: 'Sao Tome and Principe', id: 'ST' },
{ name: 'Saudi Arabia', id: 'SA' },
{ name: 'Senegal', id: 'SN' },
{ name: 'Serbia', id: 'RS' },
{ name: 'Seychelles', id: 'SC' },
{ name: 'Sierra Leone', id: 'SL' },
{ name: 'Singapore', id: 'SG' },
{ name: 'Sint Maarten (Dutch part)', id: 'SX' },
{ name: 'Slovakia', id: 'SK' },
{ name: 'Slovenia', id: 'SI' },
{ name: 'Solomon Islands', id: 'SB' },
{ name: 'Somalia', id: 'SO' },
{ name: 'South Africa', id: 'ZA' },
{ name: 'South Georgia and the South Sandwich Islands', id: 'GS' },
{ name: 'South Sudan', id: 'SS' },
{ name: 'Spain', id: 'ES' },
{ name: 'Sri Lanka', id: 'LK' },
{ name: 'Sudan (the)', id: 'SD' },
{ name: 'Suriname', id: 'SR' },
{ name: 'Svalbard and Jan Mayen', id: 'SJ' },
{ name: 'Sweden', id: 'SE' },
{ name: 'Switzerland', id: 'CH' },
{ name: 'Syrian Arab Republic', id: 'SY' },
{ name: 'Taiwan (Province of China)', id: 'TW' },
{ name: 'Tajikistan', id: 'TJ' },
{ name: 'Tanzania, United Republic of', id: 'TZ' },
{ name: 'Thailand', id: 'TH' },
{ name: 'Timor-Leste', id: 'TL' },
{ name: 'Togo', id: 'TG' },
{ name: 'Tokelau', id: 'TK' },
{ name: 'Tonga', id: 'TO' },
{ name: 'Trinidad and Tobago', id: 'TT' },
{ name: 'Tunisia', id: 'TN' },
{ name: 'Turkey', id: 'TR' },
{ name: 'Turkmenistan', id: 'TM' },
{ name: 'Turks and Caicos Islands (the)', id: 'TC' },
{ name: 'Tuvalu', id: 'TV' },
{ name: 'Uganda', id: 'UG' },
{ name: 'Ukraine', id: 'UA' },
{ name: 'United Arab Emirates (the)', id: 'AE' },
{ name: 'United Kingdom of Great Britain and Northern Ireland (the)', id: 'GB' },
{ name: 'United States Minor Outlying Islands (the)', id: 'UM' },
{ name: 'United States of America (the)', id: 'US' },
{ name: 'Uruguay', id: 'UY' },
{ name: 'Uzbekistan', id: 'UZ' },
{ name: 'Vanuatu', id: 'VU' },
{ name: 'Venezuela (Bolivarian Republic of)', id: 'VE' },
{ name: 'Viet Nam', id: 'VN' },
{ name: 'Virgin Islands (British)', id: 'VG' },
{ name: 'Virgin Islands (U.S.)', id: 'VI' },
{ name: 'Wallis and Futuna', id: 'WF' },
{ name: 'Western Sahara', id: 'EH' },
{ name: 'Yemen', id: 'YE' },
{ name: 'Zambia', id: 'ZM' },
{ name: 'Zimbabwe', id: 'ZW' },
{ name: 'Ã…land Islands', id: 'AX' }
];
